// extracted by mini-css-extract-plugin
export default {"menu__streamers":"menu__streamers--2diqu","streamers":"streamers--1J_x1","streamers__avatar":"streamers__avatar--2FBUe","streamers__texts":"streamers__texts--AFSZR","streamers__name":"streamers__name--2YIZ2","streamers__cta":"streamers__cta--qrfV6"};
    if(module.hot) {
      // 1747648179790
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  